import moment from "moment";

// Shared date math for the "lastWeek" / "thisMonth" / ... presets used by
// DateRangePicker and (potentially) CommissionReceipts/FilterTab.tsx, so the
// definition of each preset only lives in one place.
export const resolveDateRangePreset = (
  preset: string,
  customStart: Date | null = null,
  customEnd: Date | null = null
): { start: moment.Moment | null; end: moment.Moment | null } | null => {
  const today = moment().endOf("day");
  let start: moment.Moment | null = null;
  let end: moment.Moment | null = today.clone();

  switch (preset) {
    case "lastWeek":
      start = today.clone().subtract(1, "week").startOf("week");
      end = today.clone().subtract(1, "week").endOf("week");
      break;
    case "thisMonth":
      start = today.clone().startOf("month");
      break;
    case "last3Months":
      start = today.clone().subtract(3, "months").startOf("month");
      break;
    case "last6Months":
      start = today.clone().subtract(6, "months").startOf("month");
      break;
    case "last12Months":
      start = today.clone().subtract(12, "months").startOf("month");
      break;
    case "lastCalendarYear":
      start = today.clone().subtract(1, "year").startOf("year");
      end = today.clone().subtract(1, "year").endOf("year");
      break;
    case "custom":
      start = customStart ? moment(customStart) : null;
      end = customEnd ? moment(customEnd) : null;
      break;
    default:
      // Unrecognized preset key — let the caller decide how to handle it.
      return null;
  }

  return { start, end };
};
